import {ScanAndAttachModel} from "../components/models/scan-and-attach.model";

export function mapToScanAndAttach(mail: any, folder: any): ScanAndAttachModel {
  return {
    type: 'ScanAndAttach',
    SendMail: mail.SendMail,
    Mailserver: mail.Mailserver,
    Port: mail.Port,
    EnableSSL: mail.EnableSSL,
    SenderAddress: mail.SenderAddress,
    MailUsername: mail.MailUsername,
    MailPassword: mail.MailPassword,
    TestConnection: mail.TestConnection,
    ErrorMails: mail.ErrorMails,
    SourceFolder: folder.SourceFolder,
    ManualSourceFolder: folder.ManualSourceFolder,
    InProgressFolder: folder.InProgressFolder,
    TargetFolder: folder.TargetFolder,
    ErrorFolder: folder.ErrorFolder,
    ArchiveFolder: folder.ArchiveFolder,
  }
}
